


const APIMODE = {
	"LOCAL": "http://localhost:5000",
	"PRODUCAO": "https://herberts.pythonanywhere.com",
}

const URLBASE = APIMODE.PRODUCAO;


export default URLBASE